export default __webpack_public_path__ + "static/Floripa-84f735a31e6448422543350a913d960b.jpg";